<template src="./AboutTheExpert.html" />

<script>
// plugins
import RadialProgressBar from 'vue-radial-progress';
import ScrollMagic from 'scrollmagic';
import gsap from "gsap";

//vuex
import { mapState } from 'vuex';
import Analytics from '../../mixins/Analytics';

export default {
  name: "AboutTheExpert",
  data() {
    return {
      scenes: {},
      navControllers: {},
      timelines: {},
      elementsSizes: {
        extendableText: 0,
        docName: 0,
        wrapperTop: 0,
      },
      progressBarAppearancesTrigger: 0
    }
  },
  props: {
    expanded: {
      default: false,
      type: Boolean
    },
    refsState: {
      type: Object
    },
  },
  components: {
    RadialProgressBar
  },
  computed: {
    ...mapState({
          UserAgent: 'UserAgent',
          scrollPercentageWithoutFilter: 'scrollPercentage'
        }),
    scrollPercentage() {
      return this.scrollPercentageWithoutFilter < 1 ? 0 :
             this.scrollPercentageWithoutFilter > 98 ? 100 :
             this.scrollPercentageWithoutFilter.toFixed(2) * 1
    }
  },
  methods: {
    readMoreClick () {
      if(document.querySelector('.screentest')) return;
      gsap.to(window, {duration: .6, scrollTo: document.querySelector('.about__extendable_info').getBoundingClientRect().top + window.pageYOffset - 100});
    },
    calculateProgressBarTrigger() {
      const questionBlock = document.querySelector('.questions');
      const photo = document.querySelector('.about__expert_photo');
      const offset = 80;
      const trigger = questionBlock.getBoundingClientRect().top - photo.getBoundingClientRect().top + offset;
      this.progressBarAppearancesTrigger = trigger;
    },
    initPinPhoto() {
      if(this.UserAgent.window.width > 1024) {
        if(this.scenes.pinPhoto) this.scenes.pinPhoto.destroy(true);
        this.navControllers.pinPhoto = new ScrollMagic.Controller();
          this.scenes.pinPhoto = new ScrollMagic.Scene({
            triggerElement: '.about__flex_sticky',
            triggerHook: 0.075,
            offset: -125,
          })
          .setPin('.about__flex_sticky', { pushFollowers: false })
          .addTo(this.navControllers.pinPhoto);

          this.scenes.pinPhoto.on("update", () => {
            if (!document.querySelector('#app.ie')) return ;
            const circle = document.querySelector('.about__flex_sticky');
            if(circle.style.top!== 'auto' && !window.circke_offset) {
              window.circke_offset = circle.style.top
              // const style = document.createElement('style')
              // style.innerHTML = '#app.ie .about__flex_sticky.active {top: ' + circle.style.top + '!important}';
              // document.body.appendChild(style);
            }
            if(circle.style.top !== 'auto') {
              circle.classList.add('active');
            }

          });
      }
    },
    initUnzoomPhoto() {
      const offsetTriggerStart = 150;
      const offsetTriggerEnd = -40;
      if(this.UserAgent.browser.name !== 'ie' && this.UserAgent.window.width > 1024) {
        if(this.timelines.unzoomPhoto) this.timelines.unzoomPhoto.clear();
        this.timelines.unzoomPhoto = gsap.timeline({
          scrollTrigger: {
            trigger: '.about__flex',
            pin: false,
            start: `top top-=${this.elementsSizes.extendableText - this.elementsSizes.docName - offsetTriggerStart}px`,
            end: `top top-=${this.elementsSizes.extendableText - this.elementsSizes.docName - offsetTriggerEnd}px`,
            scrub: true,
          },
        });
        this.timelines.unzoomPhoto
          .to('.about__main_info_wrapper',  {opacity: 0, display: 'none'})
          .to('.about__expert_photo',  {scale: 0.7, x: 40});
      }
    },
    initHidePhoto() {
      if(this.UserAgent.browser.name !== 'ie' && this.UserAgent.window.width > 1024) {
        if(this.timelines.hidePhoto) this.timelines.hidePhoto.clear();
        this.timelines.hidePhoto = gsap.timeline({
          scrollTrigger: {
            trigger: '.questions',
            pin: false,
            start: "bottom center+=15%",
            end: "bottom center",
            scrub: true,
            // markers: true,
          }
        });
        this.timelines.hidePhoto
          .to('.about__expert_photo',  {opacity: 0, display: 'none'});
      }
    },
    initAllAnimations() {
      //calculate variables
      this.elementsSizes.docName = this.$refs.docName.clientHeight;
      this.elementsSizes.extendableText = this.$refs.extendableText.clientHeight;
      this.elementsSizes.wrapperTop = document.querySelector('.wrapper_top');
      //init animations
      this.initPinPhoto();
      this.initUnzoomPhoto();
      this.calculateProgressBarTrigger();

      if(this.UserAgent.window.height < 780) {
        this.initHidePhoto();
        window.addEventListener('scroll', function () {
          if (window.innerHeight + window.scrollY - (document.querySelector('.wrapper_top').clientHeight + document.querySelector('.wrapper_bottom').clientHeight) + 20 < document.body.offsetHeight) return;
          let photo = document.querySelector('.about__expert_photo');
          if (photo) photo.style.opacity = '0';
        });
      }
    },
  },
  watch: {
    'refsState.status': function (val) {
      if(this.UserAgent.window.height >= 780) {
        let photo = document.querySelector('.about__expert_photo');
        if (val) {
          this.initHidePhoto();
        } else {
          this.timelines.hidePhoto.clear();
        }
      }
    }
  },
  mounted() {
    this.$nextTick().then(() => {
      this.initAllAnimations();
    });
    document.addEventListener('scroll', this.calculateProgressBarTrigger);
  },
  updated() {
  },
  beforeDestroy() {
    if(this.scenes.pinPhoto) this.scenes.pinPhoto.destroy(true);
    if(this.timelines.unzoomPhoto) this.timelines.unzoomPhoto.clear();
    if(this.timelines.hidePhoto) this.timelines.hidePhoto.clear();
    document.removeEventListener('scroll', this.calculateProgressBarTrigger);
  },
  mixins: [Analytics]
}
</script>

<style scoped src="./AboutTheExpert.scss" lang="scss" />
